import * as THREE from 'three';
import { Pane } from 'tweakpane';
import Time from './Utils/Time.js';
import Sizes from './Utils/Sizes.js';
import Stats from './Utils/Stats.js';
import Resources from './Resources.js';
import Renderer from './Renderer.js';
import Camera from './Camera.js';
import World from './World.js';
import PreLoader from './Preloader.js';
import Raycaster from './Raycaster.js';

import assets from './assets.js';

export default class Experience {
  static instance;

  constructor(_options = {}) {
    if (Experience.instance) {
      return Experience.instance;
    }
    Experience.instance = this;

    // Options
    this.targetElement = _options.targetElement;

    if (!this.targetElement) {
      console.warn("Missing 'targetElement' property");
      return;
    }

    this.time = new Time();
    this.sizes = new Sizes();
    this.setConfig();
    this.setStats();
    this.setDebug();
    this.setScene();
    this.setCamera();
    this.setRenderer();
    this.setResources();
    this.setPreloader();
    this.setWorld();
    this.setRaycaster();

    this.sizes.on('resize', () => {
      this.resize();
    });

    this.update();
  }

  setConfig() {
    this.config = {};

    this.config.touch = false;
    window.addEventListener(
      'touchstart',
      () => {
        this.config.touch = true;
      },
      { once: true }
    );

    // Debug
    this.config.debug = window.location.hash === '#debug';

    // Pixel ratio
    this.config.pixelRatio = Math.min(Math.max(window.devicePixelRatio, 1), 2);

    // Width and height
    const boundings = this.targetElement.getBoundingClientRect();
    this.config.width = boundings.width;
    this.config.height = boundings.height || window.innerHeight;
    this.config.maxHeight = 750;
  }

  setStats() {
    if (this.config.debug) {
      this.stats = new Stats(true);
    }
  }

  setDebug() {
    if (this.config.debug) {
      this.debug = new Pane();
      this.debug.containerElem_.style.width = '320px';
    }
  }

  setScene() {
    this.scene = new THREE.Scene();
  }

  setCamera() {
    this.camera = new Camera();
  }

  setRenderer() {
    this.renderer = new Renderer({ rendererInstance: this.rendererInstance });

    this.targetElement.appendChild(this.renderer.instance.domElement);
  }

  setResources() {
    this.resources = new Resources(assets);
  }

  setPreloader() {
    this.preloader = new PreLoader();
  }

  setWorld() {
    this.world = new World();
  }

  setRaycaster() {
    this.raycaster = new Raycaster();
  }
  update() {
    if (this.stats) this.stats.update();

    this.camera.update();

    if (this.world) this.world.update();

    if (this.renderer) this.renderer.update();
    if (this.raycaster) this.raycaster.update();

    window.requestAnimationFrame(() => {
      this.update();
    });
  }

  resize() {
    // Config
    const boundings = this.targetElement.getBoundingClientRect();
    this.config.width = boundings.width;
    this.config.height = boundings.height;
    // this.config.maxHeight = Math.max(900, this.config.height)

    this.config.pixelRatio = Math.min(Math.max(window.devicePixelRatio, 1), 2);

    if (this.camera) this.camera.resize();

    if (this.renderer) this.renderer.resize();

    if (this.world) this.world.resize();
  }

  destroy() {}
}
